(ns bleene.dag.context-menu
  (:require ["copy-to-clipboard" :as copy]
            ["lucide-react" :refer [ChevronRight]]
            [applied-science.js-interop :as jsi]
            [bleene.dag.dag-context :as dag-context]
            [bleene.utils :as utils]
            [clojure.string :as string]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.app.utils :as app.utils]
            [minorodata.utils :as minoro.utils]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [react :as react]
            [ui.button]
            [ui.context-menu :as ui.cm]
            [ui.dialog]))


(defn focus-node [dag-id node-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:dag/navigate-to-node dag-id node-id]))

(defn filter-nodes [dag-id node-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:dag/filter-nodes dag-id node-id]))


(defn filter-nodes-in-new-tab [dag-id node-id]
  (let [new-tab-id (-> (random-uuid)
                       str)
        pane-id    :main-pane]

    (re-frame/dispatch [:dag/open-context-menu false])

    (re-frame/dispatch-sync [:dag/create-new-dag new-tab-id])
    (re-frame/dispatch-sync [:layout/add-new-tab pane-id new-tab-id true true])
    (re-frame/dispatch-sync [:dag/filter-nodes new-tab-id node-id])

    (re-frame/dispatch-sync [:layout/set-active-tab pane-id new-tab-id])

    ;; (re-frame/dispatch-sync [:dag/full-autolayout new-tab-id])
    (re-frame/dispatch [:dag/navigate-to-node new-tab-id node-id])))


(defn clear-filter [dag-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:dag/clear-filter dag-id]))


(defn launch-transform [id group-id option-id master-id]
  (let [launch #(re-frame/dispatch [:transform.api/get-latest-version-by-master-id-and-run
                                    {:type option-id
                                     :master-id master-id
                                     :old-transform-id id}])]
    (re-frame/dispatch [:transform.api/fetch-single-transform
                        {:transform-id id
                         :group-id group-id
                         :add-to-panel? false
                         :on-finish launch}])))

(defn get-source-data
  [source-id]
  (let [{:keys [sources connectors]} @(re-posh/subscribe [:connections.subs/sources-list-view])
        source-item                  (minoro.utils/find-first #(= source-id (:source/source-id %)) sources)

        {:source/keys [source-type source]} source-item]
    (app.utils/find-connector-by-type-and-version connectors source-type (:source/version source))))

(defn launch-extract [entity]
  (let [source (get-source-data (:source-id entity))]
    (re-frame/dispatch [:connections.api/start-extract-by-id
                        {:extract-id (:extract-id entity)
                         :name       (:name entity)
                         :source-id  (:source-id entity)
                         :source     source
                         :extract    entity}])))

(defn go-to-dynamic-docs [master-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:app.events/navigate :dynamic-docs-details {:entity-id master-id}]))

(defn delete [dag-id group-id transform-id master-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:dag/delete-transform group-id transform-id {:on-success [:dag/delete-node dag-id master-id]}]))

(defn delete-extract [dag-id source-id extract-id]
  (re-frame/dispatch [:dag/open-context-menu false])
  (re-frame/dispatch [:dag/delete-extract source-id extract-id {:on-success [:dag/delete-node dag-id extract-id]}]))


(defn allowed? [permissions]
  @(re-posh/subscribe [:users.subs/has-permissions? permissions]))

(defn block-native-context-menu [event]
  (jsi/call event :preventDefault)
  (jsi/call event :stopPropagation))

(defn close-context-menu [ref event]
  (jsi/call event :stopPropagation)
  (let [target (jsi/get event :target)]
    (when-not (jsi/call-in ref [:current :contains] target)
      (re-frame/dispatch [:dag/open-context-menu false]))))

(defn use-context-menu-listeners [content-ref]
  (let [on-close (partial close-context-menu content-ref)]
    (react/useEffect
     (fn []
       (jsi/call js/document :addEventListener "click" on-close)
       (jsi/call js/document :addEventListener "contextmenu" block-native-context-menu)

       (fn []
         (jsi/call js/document :removeEventListener "click" on-close)
         (jsi/call js/document :removeEventListener "contextmenu" block-native-context-menu)))
     #js [])))

(defn common-menu-items [{:keys [dag-id node-id filters]}]
  [:<>
   [ui.cm/context-menu-item
    {:on-click #(focus-node dag-id node-id)}
    "Focus on node"]

   [ui.cm/context-menu-item
    {:on-click #(filter-nodes dag-id node-id)}
    "Show subgraph"]

   [ui.cm/context-menu-item
    {:on-click #(filter-nodes-in-new-tab dag-id node-id)}
    "Show subgraph in a new tab"]

   [ui.cm/context-menu-item
    {:on-click  #(clear-filter dag-id)
     :disabled   (nil? filters)}
    "Show full graph"]])

(defn open-in-logs [params]
  (let [logs-view  @(re-posh/subscribe [:logs-view/pull])
        event-name (if (some? logs-view)
                     :logs-view/update
                     :logs-view/add)]

    (re-frame/dispatch [:dag/open-context-menu false])
    (re-frame/dispatch-sync [event-name (merge
                                         {:logs-view/term ""
                                          :logs-view/type ""
                                          :logs-view/source ""}
                                         params)])
    (re-frame/dispatch-sync [:logs.events/save-config-to-local-storage])
    (re-frame/dispatch [:app.events/navigate :log])))


(defn transform-context-menu [{:keys [dag-id node-id transform filters]}]
  (let [production-active? @(re-posh/subscribe [:environments.subs/production-active?])
        transform-id       (:transform-id transform)
        group-id           (:group-id transform)
        master-id          (:master-id transform)
        can-edit?          (or (allowed? [:connections+transforms/write])
                               (allowed? [:transforms/write]))

        on-delete    (fn []
                       (re-frame/dispatch [:dag/open-context-menu false])
                       (re-frame/dispatch [:dag/open-transform-delete-modal true {:transform-id transform-id :group-id group-id :master-id master-id}]))
        on-launch    (fn [option-id]
                       (re-frame/dispatch [:dag/open-context-menu false])
                       (launch-transform transform-id group-id option-id master-id))
        on-show-logs #(open-in-logs {:logs-view/term (:name transform)})]
    [:<>
     (if can-edit?
       [ui.cm/context-menu-sub
        {:disabled (not can-edit?)
         :content  [:<>
                    [ui.cm/context-menu-item {:on-click #(on-launch :single)}
                     "Only this one"]
                    [ui.cm/context-menu-item {:on-click #(on-launch :upstream)}
                     "Upstream"]
                    [ui.cm/context-menu-item {:on-click #(on-launch :downstream)}
                     "Downstream"]]}

        [:span {:class "flex items-center gap-2 justify-between w-full"}
         [:span "Run"]
         [:> ChevronRight {:size 16}]]]

       [ui.cm/context-menu-item {:disabled true}
        "Run"])

     [ui.cm/context-menu-item {:on-click #(re-frame/dispatch [:sql-console-modal.events/open-transform transform-id])
                               :disabled (not can-edit?)}
      "Edit SQL"]
     [ui.cm/context-menu-item {:on-click #(dispatch [:app.events/navigate-query {:transform-settings true
                                                                                 :transform-id       transform-id
                                                                                 :group-id           group-id}])
                               :disabled (or (not can-edit?) (not production-active?))}
      "Settings"]
     [ui.cm/context-menu-item {:on-click #(copy (:name transform) #js {:format "text/plain"})}
      "Copy transform name"]

     [:hr {:class "my-0.5"}]

     [common-menu-items {:dag-id  dag-id
                         :node-id node-id
                         :filters filters}]

     [:hr {:class "my-0.5"}]

     [ui.cm/context-menu-item {:on-click  #(go-to-dynamic-docs master-id)
                               :disabled   (not (allowed? :dynamic-docs/read))}
      "Show in Data docs"]

     [ui.cm/context-menu-item {:on-click on-show-logs
                               :disabled (not (allowed? :logs/read))}
      "Show in Logs"]


     [:hr {:class "my-0.5"}]

     [ui.cm/context-menu-item {:on-click on-delete
                               :class    "text-kleene-error-01"
                               :disabled (not can-edit?)}
      "Delete transform"]]))

(defn extract-context-menu [{:keys [dag-id node-id extract filters]}]
  (let [disabled     (not (or (allowed? [:connections+transforms/write])
                              (allowed? [:transforms/write])))
        source       @(re-posh/subscribe [:source/pull [:source/source-id (:source-id extract)]])

        on-delete    (fn []
                       (re-frame/dispatch [:dag/open-context-menu false])
                       (re-frame/dispatch [:dag/open-extract-delete-modal true extract]))
        on-launch    (fn []
                       (re-frame/dispatch [:dag/open-context-menu false])
                       (launch-extract extract))
        on-show-logs #(open-in-logs {:logs-view/source (string/replace
                                                        (:task-definition-name extract)
                                                        #"-extract-dev|-extract-production"
                                                        "")})
        on-edit      #(dispatch [:connector/add
                                 {:connector/action :edit-extract
                                  :connector/type   (:source/source-type source)
                                  :connector/id     (:extract-id extract)}])]
    [:<>
     [ui.cm/context-menu-item {:on-click on-launch
                               :disabled disabled}
      "Run"]
     [ui.cm/context-menu-item {:on-click on-edit
                               :disabled disabled}
      "Edit"]
     [ui.cm/context-menu-item {:on-click #(copy (:name extract) #js {:format "text/plain"})}
      "Copy extract name"]

     [:hr {:class "my-0.5"}]

     [common-menu-items {:dag-id  dag-id
                         :node-id node-id
                         :filters filters}]

     [:hr {:class "my-0.5"}]

     [ui.cm/context-menu-item {:on-click on-show-logs
                               :disabled (not (allowed? :logs/read))}
      "Show in Logs"]


     [:hr {:class "my-0.5"}]

     [ui.cm/context-menu-item {:on-click on-delete
                               :class    "text-kleene-error-01"
                               :disabled disabled}
      "Delete extract"]]))

(defn source-context-menu [{:keys [group-id source]}]
  (let [on-edit #(dispatch [:connector/add {:connector/action :edit-source
                                            :connector/type   (:source-type source)
                                            :connector/id     group-id}])]
    [ui.cm/context-menu-item {:on-click on-edit}
     "Edit source"]))

(defn group-context-menu [{:keys [group-id]}]
  (let [on-edit #(dispatch [:app.events/navigate-query {:edit-group true
                                                        :group-id   group-id}])]
    [ui.cm/context-menu-item {:on-click on-edit}
     "Edit group"]))


(defn context-menu-content []
  (let [content-ref      (react/useRef nil)
        {:keys [dag-id]} (utils/context dag-context/context)

        {{:keys [type id]} :context filters :filters}
        (utils/query {:context   [:context-menu :target]
                      :filters   [:dag dag-id :filters]})
        {{:keys [transform extract] entity-type :type} :entity}
        (utils/query {:entity    [:context-menu :target {:id [:jobs]}]})
        {{:keys [source group]} :entity}
        (utils/query {:entity    [:context-menu :target {:id [:groups]}]})]

    (use-context-menu-listeners content-ref)

    [ui.cm/context-menu-root
     [ui.cm/context-menu-trigger {:asChild true}
      [:div {:id "dag-node-dropdown-menu"}
       [:div {:ref content-ref}]]]

     [ui.cm/context-menu-content
      (cond
        (= entity-type :transform)
        [transform-context-menu {:dag-id    dag-id
                                 :node-id   id
                                 :transform transform
                                 :filters   filters}]
        (= entity-type :extract)
        [extract-context-menu {:dag-id    dag-id
                               :node-id   id
                               :extract   extract
                               :filters   filters}]
        (= type :group)
        [group-context-menu {:dag-id  dag-id
                             :group-id id
                             :group   group
                             :filters filters}]
        (= type :source)
        [source-context-menu {:dag-id   dag-id
                              :group-id id
                              :source   source
                              :filters  filters}])]]))

(defn delete-dialog
  [{:keys [entity open on-close on-confirm title]} children]
  [ui.dialog/dialog {:open open
                     :on-open-change on-close
                     :title title
                     :content [:div

                               [:<>
                                children]

                               [:div {:class "flex gap-2 mt-4 justify-end"}
                                [ui.button/button {:variant :empty
                                                   :on-click on-close}
                                 "Cancel"]
                                [ui.button/button {:data-cy   (keyword (str entity "-delete-confirm"))
                                                   :on-click (fn []
                                                               (on-confirm)
                                                               (on-close))}
                                 (str "Delete " entity)]]]}])

(defn delete-transform-dialog
  [{:keys [dag-id]}]
  (let [{:keys [delete-modal-open? metadata]}
        (utils/query {:delete-modal-open? [:transform-delete-modal :open?]
                      :metadata           [:transform-delete-modal :metadata]})

        {:keys [group-id transform-id master-id]} metadata

        close-transform-delete #(re-frame/dispatch [:dag/open-transform-delete-modal false nil])]

    [delete-dialog {:title      "Delete transform"
                    :entity     "transform"
                    :open       delete-modal-open?
                    :on-close   close-transform-delete
                    :on-confirm #(delete dag-id group-id transform-id master-id)}
     [:div
      "Are you sure you want to delete this transform?" [:br]
      [:strong "You will not be able to restore it back."]]]))

(defn delete-extract-dialog
  [{:keys [dag-id]}]
  (let [{:keys [delete-modal-open? metadata]}
        (utils/query {:delete-modal-open? [:extract-delete-modal :open?]
                      :metadata           [:extract-delete-modal :metadata]})

        {:keys [source-id extract-id]} metadata

        close-extract-delete #(re-frame/dispatch [:dag/open-extract-delete-modal false nil])]

    [delete-dialog {:title      "Delete extract"
                    :entity     "extract"
                    :open       delete-modal-open?
                    :on-close   close-extract-delete
                    :on-confirm #(delete-extract dag-id source-id extract-id)}
     [:div
      "Are you sure you want to delete this extract?" [:br]
      [:strong "You will not be able to restore it back."]]]))

(defn context-menu [{:keys [stage-ref]}]
  (let [{:keys [dag-id]} (utils/context dag-context/context)]

    [:<>
     [delete-transform-dialog {:dag-id dag-id}]
     [delete-extract-dialog {:dag-id dag-id}]

     [:f> context-menu-content
      {:stage-ref stage-ref}]]))
